import { Modal, Typography } from 'antd';
import { IConfirmation } from "../../model/CommonModel";

const ConfirmationModal = ({ hideModal, confirmClicked, openModal, label, promiseInProgress = false,
    children, okText = 'Yes', title = "Confirm", okType = 'primary' }: IConfirmation) => {
    return (
        <Modal
            maskClosable={false}
            title={title}
            open={openModal}
            okType={okType}
            onOk={confirmClicked}
            onCancel={hideModal}
            okText={okText}
            cancelText="No"
            confirmLoading={promiseInProgress}
        >
            <>
                <Typography.Text>{label}</Typography.Text>
                {children}
            </>
        </Modal>
    )
}
export default ConfirmationModal